import { createSvgIcon } from '@mui/material';

const NationalIcon = createSvgIcon(
  <svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.2312" cy="22.9097" r="22.2312" fill="white" />
    <path
      d="M33.8374 17.9317L36.0007 15.7761C36.0007 15.7761 34.6046 12.2295 29.587 9.30951L27.4237 11.4651L29.9325 13.9649L29.3727 14.5228C23.8713 9.83979 15.5915 10.494 10.8918 15.9827C8.85294 18.3656 7.74021 21.4026 7.75403 24.5361C7.78859 31.7533 13.6909 37.5726 20.9271 37.5382C28.1701 37.5038 34.0102 31.6225 33.9757 24.4121C33.9619 21.32 32.8491 18.338 30.831 15.9896L31.3908 15.4318L33.8374 17.9317ZM31.1144 24.3226C31.0591 29.9835 26.4008 34.5287 20.7197 34.4667C15.0386 34.4116 10.4771 29.77 10.5393 24.1091C10.5946 18.4757 15.2045 13.9443 20.8649 13.9649C26.5598 14.02 31.1351 18.6479 31.1213 24.3226H31.1144Z"
      fill="#85C440"
    />
    <g clipPath="url(#clip0_793_1395)" transform="translate(2.5, 0)">
      <path
        d="M12.1079 22.5385H24.8925M11.1079 27.4615H24.8925M17.5896 17.6154C14.767 22.1364 14.767 27.8636 17.5896 32.3846M18.4102 17.6154C21.2327 22.1364 21.2327 27.8636 18.4102 32.3846M25.3845 25C25.3845 29.0784 22.0783 32.3846 17.9998 32.3846C13.9214 32.3846 10.6152 29.0784 10.6152 25C10.6152 20.9216 13.9214 17.6154 17.9998 17.6154C22.0783 17.6154 25.3845 20.9216 25.3845 25Z"
        stroke="#323634"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_793_1395">
        <rect width="16" height="16" fill="white" transform="translate(10 17)" />
      </clipPath>
    </defs>
  </svg>,
  'NationalIcon',
);

export default NationalIcon;
